import React from 'react'
import { AutoColumn } from '../../../../components/Column'
import styled from 'styled-components'
import NFTMarketPlaceMenu from '../../components/NFTMarketPlaceMenu'
import NFTMyWallet from './Wallet/NFTMyWallet'
import { INFTProfile } from '../../models/INFTProfile'
import { ChainId } from '@yetiswap/sdk'
import { useWeb3React } from '@web3-react/core'

const PageWrapper = styled.div`
  max-width: 1024px;
  width: 100%;
`

const ConnectWarning = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 3rem;
  font-weight: bold;
`

export default function NFTProfile(props: INFTProfile) {
  const { chainId, account } = useWeb3React()
  const { accountParam } = props.match.params
  const userAccount = accountParam ? accountParam : account ? account : ''
  return (
    <PageWrapper>
      <AutoColumn style={{ width: '100%', maxWidth: '1024' }}>
        <NFTMarketPlaceMenu />
        {chainId !== ChainId.FUJI ? (
          <ConnectWarning>
            PLEASE CONNECT TO <br /> AVALANCHE FUJI C-CHAIN
          </ConnectWarning>
        ) : (
          <NFTMyWallet userAccount={userAccount} match={props.match} location={props.location} />
        )}
      </AutoColumn>
    </PageWrapper>
  )
}
